// Central login-mode configuration. REACT_APP_LOGIN_MODE mirrors the backend
// AUTH_LOGIN_MODE flag: "email" | "mobile" | "both". Phone flows stay hidden
// until the Exotel SMS transport is live (flip the env to "both"/"mobile").
const rawMode = String(process.env.REACT_APP_LOGIN_MODE || "email").toLowerCase();

export const LOGIN_MODE = ["email", "mobile", "both"].includes(rawMode) ? rawMode : "email";
export const PHONE_AUTH_ENABLED = LOGIN_MODE !== "email";
export const EMAIL_AUTH_ENABLED = LOGIN_MODE !== "mobile";
